import { render, staticRenderFns } from "./politica-de-cookies.vue?vue&type=template&id=46369a84&"
import script from "./politica-de-cookies.vue?vue&type=script&lang=js&"
export * from "./politica-de-cookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports